/**
 * Pure helper for reconstructing the welcome-page message body with pasted
 * text spliced at its anchor position. Extracted from WelcomePage so it can
 * be unit-tested without pulling in React or router dependencies.
 */
import { reconstructContent } from '@shared/components/attachments/pasteAnchors';

import type { Attachment } from '@shared/components/attachments/types';

/**
 * Reconstruct the message body with pasted text spliced at its anchor position.
 * Un-anchored pasted chips fall back to fenced blocks appended at the end.
 */
export function buildFullText(messageContent: string, attachments: Attachment[] | undefined): string {
  const { inlineContent, unanchoredBlocks } = reconstructContent(messageContent, attachments ?? []);
  return unanchoredBlocks.reduce((acc, block) => `${acc}\n\n${block}`, inlineContent);
}
